module.exports = __webpack_public_path__ + "static/media/tm19_1.cf5655d8.webp";